import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import tecnicoCmdService from "./services";

interface CmdState {
  centralParams: any | null;
  comandoPendente: any | null;
  loading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: CmdState = {
  centralParams: null,
  comandoPendente: null,
  loading: false,
  error: null,
  success: false,
};

export const fetchCentralParams = createAsyncThunk(
  "tecnicoCmd/fetchParams",
  async (idCentral: number, thunkAPI) => {
    try {
      return await tecnicoCmdService.getCentralParam(idCentral);
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Erro ao buscar parâmetros",
      );
    }
  },
);

export const enviarComandoRemoto = createAsyncThunk(
  "tecnicoCmd/enviar",
  async (payload: any, thunkAPI) => {
    try {
      const response = await tecnicoCmdService.postCmd(payload);
      if (response === "ok" || response.result === "ok") {
        return response;
      }
      throw new Error(response.mensagem || "Erro ao enfileirar comando");
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message || "Falha na comunicação");
    }
  },
);

export const cancelarComandos = createAsyncThunk(
  "tecnicoCmd/cancelar",
  async (idCentral: number, thunkAPI) => {
    try {
      return await tecnicoCmdService.cancelarCentralCmd(idCentral);
    } catch (error: any) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Erro ao cancelar",
      );
    }
  },
);

const tecnicoCmdSlice = createSlice({
  name: "tecnicoCmd",
  initialState,
  reducers: {
    resetCmdStatus: (state) => {
      state.success = false;
      state.error = null;
      state.loading = false;
    },
    clearCentralData: (state) => {
      state.centralParams = null;
      state.comandoPendente = null;
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(fetchCentralParams.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCentralParams.fulfilled, (state, action) => {
        state.loading = false;
        state.centralParams = action.payload;
      })
      .addCase(fetchCentralParams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      .addCase(enviarComandoRemoto.pending, (state) => {
        state.loading = true;
        state.success = false;
      })
      .addCase(enviarComandoRemoto.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(enviarComandoRemoto.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { resetCmdStatus, clearCentralData } = tecnicoCmdSlice.actions;
export default tecnicoCmdSlice.reducer;
